export const GET_ONE_PRODUCT_BY_MERCHANT = "ONE_PRODUCT_ONE_PRODUCT_BY_MERCHANT";
